module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "expand.b814e1a1.svg";